var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 20,
    viewBox: "0 0 110 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 16,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "currentColor"
  }, "REGA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 16,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 400,
    fill: "currentColor"
  }, "SCAN")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f573d7be172f87130f1db88b60ab73f.svg";
export { ForwardRef as ReactComponent };